// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__3Fn0I","inner":"Form_inner__1VaTm","range":"Form_range__2Z6T_","name":"Form_name__1z1DM","actions":"Form_actions__901nS"};